import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../services/api';

// Notificaciones persistidas por usuario (backend: routes/notificaciones.js, tablas
// sistema.notificacion + sistema.notificacion_destinatario). Distinto de
// useAuditoriaNotificaciones (useAuditoria.ts), que lee la sistema.notificaciones vieja
// y solo alimenta el dashboard de auditoría.

export const useNotificacionesUsuario = (
  params?: {
    leida?: boolean;
    tipo?: string;
    prioridad?: 'alta' | 'media' | 'baja';
    descartada?: boolean;
    limit?: number;
    offset?: number;
  },
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ['notificaciones', 'usuario', params],
    queryFn: () => apiService.getNotificaciones(params),
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    retry: 2,
    enabled: options?.enabled !== false,
  });
};

export const useNotificacionesNoLeidasCount = () => {
  return useQuery({
    queryKey: ['notificaciones', 'usuario', 'no-leidas-count'],
    queryFn: () => apiService.getNotificacionesNoLeidasCount(),
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    retry: 2,
  });
};

// Envío manual (panel de administración, permiso notifications.manage). Invalida la
// bandeja al terminar para que el propio remitente vea su notificación si se incluyó
// como destinatario.
export const useCrearNotificacionManual = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      tipo?: string;
      titulo: string;
      mensaje: string;
      prioridad?: 'alta' | 'media' | 'baja';
      entidad_tipo?: string;
      entidad_id?: string | number;
      metadata?: Record<string, any>;
      expira_en?: string;
      destinatarios: { roles?: string[]; usuarioIds?: number[] };
    }) => apiService.crearNotificacionManual(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['notificaciones', 'usuario']);
    },
  });
};
